import React, { useState, useMemo } from 'react';
import './GamesPage.css';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import GameCard from '../components/GameCard';
import { useGames } from '../hooks/useGames';

export default function GamesPage() {
  const { games, loading, error } = useGames();
  const [activeCategory, setActiveCategory] = useState('All');

  const categories = useMemo(() => {
    const set = new Set(games.map(g => g.category).filter(Boolean));
    return ['All', ...Array.from(set)];
  }, [games]);

  const filtered = activeCategory === 'All'
    ? games
    : games.filter(g => g.category === activeCategory);

  return (
    <div className="games-page-root">
      <Nav />

      <header className="games-page-header">
        <div className="games-page-header-bg" />
        <div className="games-page-header-inner">
          <div className="eyebrow">Full Catalog</div>
          <h1 className="games-page-title">All Games</h1>
          <p className="section-sub">
            Browse every provably-fair title on the platform. Pick one and jump straight into the demo.
          </p>
        </div>
      </header>

      <section className="section games-page-section">
        <div className="section-inner">
          {!loading && !error && categories.length > 2 && (
            <div className="category-chips">
              {categories.map(cat => (
                <button
                  key={cat}
                  className={`category-chip${activeCategory === cat ? ' active' : ''}`}
                  onClick={() => setActiveCategory(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>
          )}

          {loading && (
            <div className="games-loading">
              <div className="games-loading-spinner" />
              <p>Loading games…</p>
            </div>
          )}

          {error && (
            <div className="games-error">
              <p>Could not load games. Please try again later.</p>
            </div>
          )}

          {!loading && !error && (
            <div className="games-grid">
              {filtered.map(game => (
                <GameCard key={game.id} game={game} />
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
